import {cylinder_pos} from "./jokerboom_config";
import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_to_group, madnes_key_exist,
    madnes_set_angle,
    madnes_set_scale,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_scale_to} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_add_graphics,
    madnes_add_mask,
    madnes_graphics_begin_fill,
    madnes_graphics_draw_rectangle
} from "../framework/src/engine/madnes/madnes_draw";
import {madnes_angle_between, madnes_distance, madnes_rad_to_deg} from "../framework/src/engine/madnes/madnes";
import {he, wi} from "../framework/src/engine/madnes/madnes_variables";

var winlines_pos_x = [];
var winlines_pos_y = [];
var winline_length = 287;

export function draw_winlines()
{
    var sPosX = winlines_pos_x; //[195, 485, 785, 0]

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        sPosX[i] = cylinder_pos[i];
    }

    winlines_pos_y = [160, 350, 550, 0];

    draw_winline_2(0, 0, [0, 0], [1, 0]);
    draw_winline_2(0, 1, [1, 0], [2, 0]);
    draw_winline_2(0, 2, [2, 0], [3, 0]);

    draw_winline_2(1, 0, [0, 0], [1, 0]);
    draw_winline_2(1, 1, [1, 0], [2, 0]);
    draw_winline_2(1, 2, [2, 0], [3, 1]);

    draw_winline_2(2, 0, [0, 0], [1, 0]);
    draw_winline_2(2, 1, [1, 0], [2, 0]);
    draw_winline_2(2, 2, [2, 0], [3, 2]);

    draw_winline_2(3, 0, [0, 0], [1, 0]);
    draw_winline_2(3, 1, [1, 0], [2, 1]);
    draw_winline_2(3, 2, [2, 1], [3, 0]);

    draw_winline_2(4, 0, [0, 0], [1, 0]);
    draw_winline_2(4, 1, [1, 0], [2, 1]);
    draw_winline_2(4, 2, [2, 1], [3, 1]);

    draw_winline_2(5, 0, [0, 0], [1, 0]);
    draw_winline_2(5, 1, [1, 0], [2, 1]);
    draw_winline_2(5, 2, [2, 1], [3, 2]);

    draw_winline_2(6, 0, [0, 0], [1, 0]);
    draw_winline_2(6, 1, [1, 0], [2, 2]);
    draw_winline_2(6, 2, [2, 2], [3, 0]);

    draw_winline_2(7, 0, [0, 0], [1, 0]);
    draw_winline_2(7, 1, [1, 0], [2, 2]);
    draw_winline_2(7, 2, [2, 2], [3, 1]);

    draw_winline_2(8, 0, [0, 0], [1, 0]);
    draw_winline_2(8, 1, [1, 0], [2, 2]);
    draw_winline_2(8, 2, [2, 2], [3, 2]);

    draw_winline_2(9, 0, [0, 0], [1, 1]);
    draw_winline_2(9, 1, [1, 1], [2, 0]);
    draw_winline_2(9, 2, [2, 0], [3, 0]);

    draw_winline_2(10, 0, [0, 0], [1, 1]);
    draw_winline_2(10, 1, [1, 1], [2, 0]);
    draw_winline_2(10, 2, [2, 0], [3, 1]);

    draw_winline_2(11, 0, [0, 0], [1, 1]);
    draw_winline_2(11, 1, [1, 1], [2, 0]);
    draw_winline_2(11, 2, [2, 0], [3, 2]);

    draw_winline_2(12, 0, [0, 0], [1, 1]);
    draw_winline_2(12, 1, [1, 1], [2, 1]);
    draw_winline_2(12, 2, [2, 1], [3, 0]);

    draw_winline_2(13, 0, [0, 0], [1, 1]);
    draw_winline_2(13, 1, [1, 1], [2, 1]);
    draw_winline_2(13, 2, [2, 1], [3, 1]);

    draw_winline_2(14, 0, [0, 0], [1, 1]);
    draw_winline_2(14, 1, [1, 1], [2, 1]);
    draw_winline_2(14, 2, [2, 1], [3, 2]);

    draw_winline_2(15, 0, [0, 0], [1, 1]);
    draw_winline_2(15, 1, [1, 1], [2, 2]);
    draw_winline_2(15, 2, [2, 2], [3, 0]);

    draw_winline_2(16, 0, [0, 0], [1, 1]);
    draw_winline_2(16, 1, [1, 1], [2, 2]);
    draw_winline_2(16, 2, [2, 2], [3, 1]);

    draw_winline_2(17, 0, [0, 0], [1, 1]);
    draw_winline_2(17, 1, [1, 1], [2, 2]);
    draw_winline_2(17, 2, [2, 2], [3, 2]);

    draw_winline_2(18, 0, [0, 0], [1, 2]);
    draw_winline_2(18, 1, [1, 2], [2, 0]);
    draw_winline_2(18, 2, [2, 0], [3, 0]);

    draw_winline_2(19, 0, [0, 0], [1, 2]);
    draw_winline_2(19, 1, [1, 2], [2, 0]);
    draw_winline_2(19, 2, [2, 0], [3, 1]);

    draw_winline_2(20, 0, [0, 0], [1, 2]);
    draw_winline_2(20, 1, [1, 2], [2, 0]);
    draw_winline_2(20, 2, [2, 0], [3, 2]);

    draw_winline_2(21, 0, [0, 0], [1, 2]);
    draw_winline_2(21, 1, [1, 2], [2, 1]);
    draw_winline_2(21, 2, [2, 1], [3, 0]);

    draw_winline_2(22, 0, [0, 0], [1, 2]);
    draw_winline_2(22, 1, [1, 2], [2, 1]);
    draw_winline_2(22, 2, [2, 1], [3, 1]);

    draw_winline_2(23, 0, [0, 0], [1, 2]);
    draw_winline_2(23, 1, [1, 2], [2, 1]);
    draw_winline_2(23, 2, [2, 1], [3, 2]);

    draw_winline_2(24, 0, [0, 0], [1, 2]);
    draw_winline_2(24, 1, [1, 2], [2, 2]);
    draw_winline_2(24, 2, [2, 2], [3, 0]);

    draw_winline_2(25, 0, [0, 0], [1, 2]);
    draw_winline_2(25, 1, [1, 2], [2, 2]);
    draw_winline_2(25, 2, [2, 2], [3, 1]);

    draw_winline_2(26, 0, [0, 0], [1, 2]);
    draw_winline_2(26, 1, [1, 2], [2, 2]);
    draw_winline_2(26, 2, [2, 2], [3, 2]);

    draw_winline_2(27, 0, [0, 1], [1, 0]);
    draw_winline_2(27, 1, [1, 0], [2, 0]);
    draw_winline_2(27, 2, [2, 0], [3, 0]);

    draw_winline_2(28, 0, [0, 1], [1, 0]);
    draw_winline_2(28, 1, [1, 0], [2, 0]);
    draw_winline_2(28, 2, [2, 0], [3, 1]);

    draw_winline_2(29, 0, [0, 1], [1, 0]);
    draw_winline_2(29, 1, [1, 0], [2, 0]);
    draw_winline_2(29, 2, [2, 0], [3, 2]);

    draw_winline_2(30, 0, [0, 1], [1, 0]);
    draw_winline_2(30, 1, [1, 0], [2, 1]);
    draw_winline_2(30, 2, [2, 1], [3, 0]);

    draw_winline_2(31, 0, [0, 1], [1, 0]);
    draw_winline_2(31, 1, [1, 0], [2, 1]);
    draw_winline_2(31, 2, [2, 1], [3, 1]);

    draw_winline_2(32, 0, [0, 1], [1, 0]);
    draw_winline_2(32, 1, [1, 0], [2, 1]);
    draw_winline_2(32, 2, [2, 1], [3, 2]);

    draw_winline_2(33, 0, [0, 1], [1, 0]);
    draw_winline_2(33, 1, [1, 0], [2, 2]);
    draw_winline_2(33, 2, [2, 2], [3, 0]);

    draw_winline_2(34, 0, [0, 1], [1, 0]);
    draw_winline_2(34, 1, [1, 0], [2, 2]);
    draw_winline_2(34, 2, [2, 2], [3, 1]);

    draw_winline_2(35, 0, [0, 1], [1, 0]);
    draw_winline_2(35, 1, [1, 0], [2, 2]);
    draw_winline_2(35, 2, [2, 2], [3, 2]);

    draw_winline_2(36, 0, [0, 1], [1, 1]);
    draw_winline_2(36, 1, [1, 1], [2, 0]);
    draw_winline_2(36, 2, [2, 0], [3, 0]);

    draw_winline_2(37, 0, [0, 1], [1, 1]);
    draw_winline_2(37, 1, [1, 1], [2, 0]);
    draw_winline_2(37, 2, [2, 0], [3, 1]);

    draw_winline_2(38, 0, [0, 1], [1, 1]);
    draw_winline_2(38, 1, [1, 1], [2, 0]);
    draw_winline_2(38, 2, [2, 0], [3, 2]);

    draw_winline_2(39, 0, [0, 1], [1, 1]);
    draw_winline_2(39, 1, [1, 1], [2, 1]);
    draw_winline_2(39, 2, [2, 1], [3, 0]);

    draw_winline_2(40, 0, [0, 1], [1, 1]);
    draw_winline_2(40, 1, [1, 1], [2, 1]);
    draw_winline_2(40, 2, [2, 1], [3, 1]);

    draw_winline_2(41, 0, [0, 1], [1, 1]);
    draw_winline_2(41, 1, [1, 1], [2, 1]);
    draw_winline_2(41, 2, [2, 1], [3, 2]);

    var k = 41;
    k++;
    draw_winline_2(k, 0, [0, 1], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 1], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 1], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 2]);

    k = 44;
    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 2]);

    k = 47;
    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 2]);

    k = 50;
    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 1], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 2]);

    k = 53;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 2]);

    k = 56;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 2]);

    k = 59;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 0]);
    draw_winline_2(k, 1, [1, 0], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 2]);

    k = 62;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 2]);

    k = 65;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 2]);

    k = 68;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 1]);
    draw_winline_2(k, 1, [1, 1], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 2]);

    k = 71;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 0]);
    draw_winline_2(k, 2, [2, 0], [3, 2]);

    k = 74;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 1]);
    draw_winline_2(k, 2, [2, 1], [3, 2]);

    k = 77;
    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 0]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 1]);

    k++;
    draw_winline_2(k, 0, [0, 2], [1, 2]);
    draw_winline_2(k, 1, [1, 2], [2, 2]);
    draw_winline_2(k, 2, [2, 2], [3, 2]);

    /**/

    madnes_add_group("group_winlines");
    for(var i = 0; i <= 80; i++)
    {
        madnes_add_to_group("group_winlines", "group_winline_" + i);
    }

    madnes_add_graphics("graphics_winline_mask", 0, 0);
    madnes_graphics_begin_fill("graphics_winline_mask", 0x000000);
    madnes_graphics_draw_rectangle("graphics_winline_mask", 0, 0, wi, he);

    madnes_set_scale("graphics_winline_mask", 0, 1);

    madnes_add_mask("group_winlines", "graphics_winline_mask");

}

function draw_winline(line, part, xPos, yPos, length, angle)
{
    if(!madnes_key_exist("group_winline_" + line))
    {
        madnes_add_group("group_winline_" + line);
    }

    madnes_add_img("winline_" + line + "_line_" + part, "winline_0", xPos, yPos, 1, 0, 0.5);
    madnes_set_scale("winline_" + line +  "_line_" + part, length, 1);
    angle && madnes_set_angle("winline_" + line + "_line_" + part, angle);
    madnes_add_to_group("group_winline_" + line, "winline_" + line + "_line_" + part);
}

function draw_winline_2(line, part, pos1, pos2)
{
    var posX1 = winlines_pos_x[pos1[0]];
    var posY1 = winlines_pos_y[pos1[1]];
    var posX2 = winlines_pos_x[pos2[0]];
    var posY2 = winlines_pos_y[pos2[1]];

    var dist = madnes_distance(posX1, posY1, posX2, posY2);
    var len = dist / winline_length;

    draw_winline(line, part, posX1, posY1, len, madnes_rad_to_deg(madnes_angle_between(posX1, posY1, posX2, posY2)));
}

export function anim_winlines(lineWins)
{
    return new Promise(function(res) {

        hide_all_winlines();

        for(var i = 0; i < lineWins.length; i++) {
            var lineWin = lineWins[i];

            madnes_set_visible("group_winline_" + lineWin.line, true);
            set_linewin_length(lineWin.line, lineWin.position.length - 1);
        }

        madnes_set_scale("graphics_winline_mask", 0, 1);
        madnes_scale_to("graphics_winline_mask", 1, 1, 600, res);
    });
}

function set_linewin_length(line, len)
{
    for(var i = 0; i < cylinder_pos.length; i++) {

        if(madnes_key_exist("winline_" + line + "_line_" + i))
        {
            if(i < len)
            {
                madnes_set_visible("winline_" + line + "_line_" + i, true);
            }
            else
            {
                madnes_set_visible("winline_" + line + "_line_" + i, false);
            }
        }
    }
}

export function hide_all_winlines()
{
    for(var i = 0; i < 81; i++)
    {
        madnes_set_visible("group_winline_" + i, false);
    }
}